import vuvuzela from 'vuvuzela';

function safeJsonParse(str) {
  // This try/catch guards against stack overflow errors.
  // JSON.parse() is faster than vuvuzela.parse() but vuvuzela
  // cannot overflow.
  try {
    return JSON.parse(str);
  } catch (e) {
    /* istanbul ignore next */
    return vuvuzela.parse(str);
  }
}

function safeJsonStringify(json) {
  try {
    return JSON.stringify(json);
  } catch (e) {
    /* istanbul ignore next */
    return vuvuzela.stringify(json);
  }
}

export { safeJsonParse, safeJsonStringify };



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-json/lib/index.es.js
// module id = 2716
// module chunks = 0